import { render, staticRenderFns } from "./Photograph.vue?vue&type=template&id=67f6f2c6&scoped=true&"
import script from "./Photograph.vue?vue&type=script&lang=js&"
export * from "./Photograph.vue?vue&type=script&lang=js&"
import style0 from "./Photograph.vue?vue&type=style&index=0&id=67f6f2c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f6f2c6",
  null
  
)

export default component.exports